import React from "react";

import { createSlotManager } from "@teamrota/shiftstreamlib";
import { COLORS } from "~/src/styles/config.style";
import {
  formatDateMonthTimeShort,
  formatHoursMinutes,
} from "~/src/utils/formatting";

export function cleanAddress(email: string) {
  return email.replace(/@ttmhealthcare\.(com|ie)/g, "@");
}

export function getFillText(stream: any) {
  const slotManager = createSlotManager(stream.account, stream);

  const total = slotManager.totalCount();
  const filled = slotManager.filledCount();

  const percent = total > 0 ? Math.round((filled / total) * 100) : -1;

  const color =
    percent < 0
      ? COLORS.GREY_DARK
      : percent > 80
        ? COLORS.GREEN
        : percent > 0
          ? COLORS.MAIN_ORANGE
          : COLORS.RED;

  return (
    <span style={{ whiteSpace: "nowrap", color }}>
      {filled} of {total}
    </span>
  );
}

export function getTooltip(stream: any) {
  return (
    stream.shift.sourceAccount.accountName +
    "\n" +
    stream.shift.venue.name +
    "\n" +
    stream.shift.role.name +
    "\n" +
    formatDateMonthTimeShort(stream.shift.startTime) +
    " to " +
    formatHoursMinutes(stream.shift.endTime)
  );
}

/**
 * Nicer rendering of state + associated info
 */
export function getEmailStatus(email: any) {
  switch (email.state) {
    case "PENDING":
      return <>⌛️ Pending</>;

    case "ERROR":
      if (email.errorMessage) {
        return <div style={{ fontSize: "80%" }}>⛔️ {email.errorMessage}</div>;
      } else {
        return <>⛔️ Error</>;
      }

    case "SKIPPED":
      return <>⏭️ Skipped</>;

    case "PARTIAL":
      return <>⚠️ Partial</>;

    case "COULD_NOT_PARSE": {
      if (email.responseMessage) {
        return (
          <div style={{ fontSize: "80%" }}>❌ {email.responseMessage}</div>
        );
      } else {
        return <>❌ Could Not Parse</>;
      }
    }

    case "PARSED":
      return <>✅ Parsed</>;
  }

  return <>Unknown</>;
}

export function toHumanDuration(secondsAgo: number) {
  if (secondsAgo < 60) {
    return `${secondsAgo}s ago`;
  } else if (secondsAgo < 3600) {
    const mins = Math.round(secondsAgo / 60);
    return `${mins}m ago`;
  } else if (secondsAgo < 3600 * 24) {
    const hours = Math.round(secondsAgo / 3600);
    return `${hours}h ago`;
  } else {
    const days = Math.round(secondsAgo / (3600 * 24));
    return `${days}d ago`;
  }
}

export function getStateColor(stream: any) {
  const isStarted = stream.state === "STARTED";
  const isMissed = stream.state === "MISSED";
  const isCancelled = stream.state === "CANCELLED";
  const isGone = stream.state === "GONE";
  const isReady = stream.state === "READY";

  const color = isReady
    ? COLORS.MAIN_ORANGE
    : isCancelled
      ? COLORS.RED
      : isMissed || isGone || isStarted
        ? COLORS.WARM_GREY
        : COLORS.MAIN_ORANGE;

  return color;
}
